import { BaseColumnType } from '@/shared/components/table/typings';

/** 序号配置 */
export const SerialNumberConfig: BaseColumnType = {
  title: '序号',
  width: 80,
  fixed: 'left',
  render: (...args) => args[2] + 1,
};

/** 高德地图的key */
export const amapKey = '2f9f2a1035483ebb82dcca98ee8cb406';

/** CountUp 金额默认小数位数 */
export const COUNTUP_AMOUNT_DECIMALS = 2;

/** 环境变量配置 */
export const environment = {
  NODE_ENV: process.env.NODE_ENV,
  BASE_API_URL: process.env.BASE_API_URL,
  BASE_SOCKET_URL: process.env.BASE_SOCKET_URL,
  H5_URL: process.env.H5_URL,
};
